module.exports = __webpack_public_path__ + "48c1a982d953d511295d27385e09a01b.jpg";